/* eslint-disable react/no-unescaped-entities */
import author1 from "../../assets/images/all-img/v5/author1.png";
import author2 from "../../assets/images/all-img/v5/author2.png";
import author3 from "../../assets/images/all-img/v5/author3.png";
import author4 from "../../assets/images/all-img/v5/author4.png";
import author5 from "../../assets/images/all-img/v5/author5.png";
import author6 from "../../assets/images/all-img/v5/author6.png";
import star from "../../assets/images/svg2/star.svg";

import { Link } from "react-router-dom";

export default function TestimonialSection() {
	return (
		<div className="fugu--testimonial-section fugu--section-padding">
			<div className="container">
				<div className="fugu--section-title">
					<div className="fugu--default-content">
						<h2>Users around the world have a great experience with Fugu</h2>
						<p>
							Fugu is a place of trust for millions of people. Our customer reviews overall and is rated
							just 4.5 out of 5 stars on Trustpilot. It is the right place for you.
						</p>
					</div>
				</div>
				<div className="row">
					<div className="col-xl-4 col-md-6">
						<div className="fugu--testimonial-wrap wow fadeInUpX" data-wow-delay="0s">
							<div className="fugu--testimonial-rating">
								<ul>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
								</ul>
							</div>
							<div className="fugu--testimonial-data">
								<p>
									“I found Fugu very professional and trustworthy during my crypto trading duration of
									147 days. They are very honest and trusted.”
								</p>
							</div>
							<div className="fugu--testimonial-author">
								<div className="fugu--testimonial-author-thumb">
									<img src={author1} alt="" />
								</div>
								<div className="fugu--testimonial-author-data">
									<span>- Karen Lynn</span>
									<p>Founder @ Company</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div className="fugu--testimonial-wrap wow fadeInUpX" data-wow-delay=".10s">
							<div className="fugu--testimonial-rating">
							<ul>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
								</ul>
							</div>
							<div className="fugu--testimonial-data">
								<p>
									“100% Trusted. Very legit in crypto world. So far I'm satisfied with Fugu. I just
									wish this will continue at this way and there will be no sudden changes.”
								</p>
							</div>
							<div className="fugu--testimonial-author">
								<div className="fugu--testimonial-author-thumb">
									<img src={author2} alt="" />
								</div>
								<div className="fugu--testimonial-author-data">
									<span>- Subash Rajendran</span>
									<p>Software engineer</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div className="fugu--testimonial-wrap wow fadeInUpX" data-wow-delay=".20s">
							<div className="fugu--testimonial-rating">
							<ul>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
								</ul>
							</div>
							<div className="fugu--testimonial-data">
								<p>
									“The best place to start your trading path, thank you for support. Its a safe
									passive income strategy and will be multiply over time 😍.”
								</p>
							</div>
							<div className="fugu--testimonial-author">
								<div className="fugu--testimonial-author-thumb">
									<img src={author3} alt="" />
								</div>
								<div className="fugu--testimonial-author-data">
									<span>- Milan Milenkovic</span>
									<p>Businessman</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div className="fugu--testimonial-wrap wow fadeInUpX" data-wow-delay=".30s">
							<div className="fugu--testimonial-rating">
							<ul>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
								</ul>
							</div>
							<div className="fugu--testimonial-data">
								<p>
									“Trustable ☺️ Best way to earn passive income. Everything was well explained and it
									was easy to follow their clear. Very legit in crypto world.”
								</p>
							</div>
							<div className="fugu--testimonial-author">
								<div className="fugu--testimonial-author-thumb">
									<img src={author4} alt="" />
								</div>
								<div className="fugu--testimonial-author-data">
									<span>- Francois Malan</span>
									<p>UI/UX Designer</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div className="fugu--testimonial-wrap wow fadeInUpX" data-wow-delay=".40s">
							<div className="fugu--testimonial-rating">
							<ul>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
								</ul>
							</div>
							<div className="fugu--testimonial-data">
								<p>
									“More than just satisfied.Trustable site and the owner is very friendly & calm. And
									it’s great! The 0,5-1% daily on average is the target.”
								</p>
							</div>
							<div className="fugu--testimonial-author">
								<div className="fugu--testimonial-author-thumb">
									<img src={author5} alt="" />
								</div>
								<div className="fugu--testimonial-author-data">
									<span>- Nadir Zeblah</span>
									<p>Manager @ Company</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-md-6">
						<div className="fugu--testimonial-wrap wow fadeInUpX" data-wow-delay=".50s">
							<div className="fugu--testimonial-rating">
							<ul>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
									<li>
										<img src={star} alt="" />
									</li>
								</ul>
							</div>
							<div className="fugu--testimonial-data">
								<p>
									“Best crypto scam investigator. It took less than 24h and gave all the details about
									the scammer and guided me. My heartfull thanks 💗 ”
								</p>
							</div>
							<div className="fugu--testimonial-author">
								<div className="fugu--testimonial-author-thumb">
									<img src={author6} alt="" />
								</div>
								<div className="fugu--testimonial-author-data">
									<span>- Abdul Wadud</span>
									<p>WP Developer</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="fugu--testimonial-button">
					<Link to={"#"}  >
						<a className="fugu--btn bg-blue">View All Reviews</a>
					</Link>
				</div>
			</div>
		</div>
	);
}
